import { useQuery } from '@tanstack/react-query';
import { dashboardApi, dashboardQueryKeys, type StatisticPeriod } from '../api/dashboard.api';

export function useMDStatistics(period: StatisticPeriod) {
  return useQuery({
    queryKey: dashboardQueryKeys.mdStatistics(period),
    queryFn: () => dashboardApi.getMDStatistics(period),
  });
}
